import React from 'react';

const SecurityScript = () => {
  return (
    <script src="../scripts/borders.js" type="text/javascript"></script>
  );
};

export default SecurityScript;